import { createSlice } from "@reduxjs/toolkit";
import {
  GetAllPractitionerList,
  GetAllSpeciality,
  GetIndividualParctitioner,
  SearchPractitioner,
} from "./practitionerSliceAPi";

const practitionerSlice = createSlice({
  name: "practitioners",
  initialState: {
    specilaityList: [],
    excelData: [],
    validationErrors: [],
    tableData: [],
    duplicateRows: [],
    isExcelValid: false,
    importStatus: "idle",
    individualPractitioner: null,
    practitionerListData: [],
    activeStep: 0,
    searchPractitionerList: [],
    practitionerFilters: {
      branch: "",
      name: "",
      license_number: "",
      speciality: "",
      id_number: "",
    },
  },
  reducers: {
    setExcelData: (state, action) => {
      state.excelData = action.payload;
    },
    setValidationErrors: (state, action) => {
      state.validationErrors = action.payload;
    },
    setTableData: (state, action) => {
      state.tableData = action.payload;
    },
    setDuplicateRows: (state, action) => {
      state.duplicateRows = action.payload;
    },
    updateDuplicateRow: (state, action) => {
      const { rowNum, updatedData } = action.payload;
      state.duplicateRows = state.duplicateRows.map((row) =>
        row.rowNum === rowNum ? { ...row, ...updatedData } : row
      );
    },
    deleteDuplicateRow: (state, action) => {
      const rowNum = action.payload;
      state.duplicateRows = state.duplicateRows.filter(
        (row) => row.id !== rowNum
      );
    },
    setIsExcelValid: (state, action) => {
      state.isExcelValid = action.payload;
    },
    setActiveStep: (state, action) => {
      state.activeStep = action.payload;
    },
    deleteRow: (state, action) => {
      const rowNumToDelete = action.payload;
      state.tableData = state.tableData.filter(
        (row) => row.rowNum !== rowNumToDelete
      );
    },
    updateRowData: (state, action) => {
      const { rowNum, updatedData, isValid } = action.payload;
      state.tableData = state.tableData.map((row) =>
        row.rowNum === rowNum
          ? {
              ...updatedData,
              rowNum,
              isValid,
              errors: isValid ? [] : row.errors,
            }
          : row
      );
    },
    resetImportState: (state) => {
      state.excelData = [];
      state.validationErrors = [];
      state.tableData = [];
      state.isExcelValid = false;
      state.importStatus = "idle";
      state.activeStep = 0;
    },
    startImport: (state) => {
      state.importStatus = "loading";
    },
    importSuccess: (state) => {
      state.importStatus = "succeeded";
    },
    importFailed: (state, action) => {
      state.importStatus = "failed";
      state.error = action.payload;
    },
    handlePractitonerFilter: (state, action) => {
      state.practitionerFilters[action?.payload?.check] =
        action?.payload?.value;
    },
    handlePractitonerReset: (state, _) => {
      state.practitionerFilters = {
        branch: "",
        name: "",
        license_number: "",
        speciality: "",
        id_number: "",
      };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(GetAllSpeciality.fulfilled, (state, action) => {
        state.specilaityList = action.payload?.data?.speciality;
      })
      .addCase(GetIndividualParctitioner.fulfilled, (state, action) => {
        state.individualPractitioner = action.payload?.data?.practitioner_data;
      })
      .addCase(SearchPractitioner.fulfilled, (state, action) => {
        state.searchPractitionerList = action.payload?.data?.Practitioner_data;
      })
      .addCase(GetAllPractitionerList.fulfilled, (state, action) => {
        state.practitionerListData = action.payload?.data?.practitioner_details;
      });
  },
});

export const {
  setExcelData,
  setValidationErrors,
  setTableData,
  setIsExcelValid,
  setActiveStep,
  updateRowData,
  setDuplicateTableData,
  resetImportState,
  setDuplicateRows,
  startImport,
  updateDuplicateRow,
  handlePractitonerReset,
  handlePractitonerFilter,
  importSuccess,
  deleteRow,
  importFailed,
  deleteDuplicateRow,
} = practitionerSlice.actions;

export default practitionerSlice.reducer;
